module.exports = __webpack_public_path__ + "img/sel__tables.7fc96a20.svg";